export default "__VITE_ASSET__IPsh7EuF__"